/* this file added by Bearer Web Developer  */
import { vehicle_type } from "..";
interface ActiveVehicles {
    riding: boolean;
    cycling: boolean;
    walking: boolean;
    driving: boolean;
    drone: boolean;
    rover: boolean;
}
const getActiveVehicles = (bearer_type: vehicle_type) => {

    let activeVehicles: ActiveVehicles = { riding: false, cycling: false, walking: false, driving: false, drone: false, rover: false, };
    switch (bearer_type) {
        case vehicle_type.walking:
            activeVehicles.walking = true;
            activeVehicles.cycling = true;
            activeVehicles.riding = true;
            activeVehicles.driving = true;
            break;
        case vehicle_type.cycling:
            activeVehicles.cycling = true;
            activeVehicles.riding = true;
            activeVehicles.driving = true;
            break;
        case vehicle_type.riding:
            activeVehicles.riding = true;
            activeVehicles.driving = true;
            break;
        case vehicle_type.driving:
            activeVehicles.driving = true;
            break;
        case vehicle_type.drone:
            activeVehicles.drone = true;
            break;
        case vehicle_type.rover:
            activeVehicles.rover = true;
            break;
    }
    return activeVehicles;
}
export default getActiveVehicles;
